import { isExperimentalFeatureEnabled } from '..';
export function isEventBridgePresent() {
    return !!getEventBridge();
}
function getEventBridge() {
    return isExperimentalFeatureEnabled('event-bridge') ? window.DatadogEventBridge : null;
}
//# sourceMappingURL=eventBridge.js.map